import { toast } from "react-toastify";
import {
  UpdateNotificationPreferencesDocument,
  FetchNotificationPreferencesDocument,
  UpdateNotificationPreferencesMutation,
  UpdateNotificationPreferencesMutationVariables,
} from "@/graphql/__generated__/graphql";
import { useTranslation } from "react-i18next";
import { CustomToastComponent } from "@/components/shared";
import { useMutation } from "@apollo/client/react";

/**
 * Custom hook for updating notification preferences and handling cache updates.
 * @returns {Object} - Contains the updateNotificationPreferencesMutation function, loading state, and error state.
 */
export default function useUpdateNotificationPreferencesMutationHook() {
  const { t } = useTranslation(["toasts"]);

  const [updateNotificationPreferencesMutation, { loading, error }] =
    useMutation<UpdateNotificationPreferencesMutation, UpdateNotificationPreferencesMutationVariables>(
      UpdateNotificationPreferencesDocument, {
        onCompleted() {
          toast(CustomToastComponent, {
            toastId: "notification-preferences-updated-success",
            data: {
              title: t("toasts.notificationsettingsupdated"),
              type: "success",
            },
          });
        },
        refetchQueries: [
          {
            query: FetchNotificationPreferencesDocument,
          },
        ],
      });

  return {
    updateNotificationPreferencesMutation,
    loading,
    error,
  };
}
